/*
 * Where a channel's own pages live: the channel, one of its tabs, a data set
 * and a saved view. Pure, so views and fixtures build the same links.
 */

export function channelHref(channelId: string, view?: "data" | "feed" | "files" | "memory"): string {
  const base = `/workspace/channels/${encodeURIComponent(channelId)}`;
  return view ? `${base}?view=${view}` : base;
}

export function channelDataSetHref(
  channelId: string,
  dataSetId: string,
  viewId?: string,
): string {
  const query = new URLSearchParams({ dataSet: dataSetId });
  if (viewId) query.set("view", `saved:${viewId}`);
  return `/workspace/channels/${encodeURIComponent(channelId)}?${query.toString()}`;
}

export function channelViewHref(
  channelId: string,
  dataSetId: string,
  viewId: string,
): string;
export function channelViewHref(channelId: string, viewId: string): string;
export function channelViewHref(
  channelId: string,
  dataSetOrViewId: string,
  viewId?: string,
): string {
  const query = new URLSearchParams({
    view: `saved:${viewId ?? dataSetOrViewId}`,
  });
  if (viewId) query.set("dataSet", dataSetOrViewId);
  return `/workspace/channels/${encodeURIComponent(channelId)}?${query.toString()}`;
}
